/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentLanguageMap
 */
export interface DocumentLanguageMap {
    /**
     * 
     * @type {string}
     * @memberof DocumentLanguageMap
     */
    taskId?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentLanguageMap
     */
    documentUid?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentLanguageMap
     */
    language?: string;
}

/**
 * Check if a given object implements the DocumentLanguageMap interface.
 */
export function instanceOfDocumentLanguageMap(value: object): value is DocumentLanguageMap {
    return true;
}

export function DocumentLanguageMapFromJSON(json: any): DocumentLanguageMap {
    return DocumentLanguageMapFromJSONTyped(json, false);
}

export function DocumentLanguageMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentLanguageMap {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'documentUid': json['documentUid'] == null ? undefined : json['documentUid'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function DocumentLanguageMapToJSON(json: any): DocumentLanguageMap {
    return DocumentLanguageMapToJSONTyped(json, false);
}

export function DocumentLanguageMapToJSONTyped(value?: DocumentLanguageMap | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'documentUid': value['documentUid'],
        'language': value['language'],
    };
}

